import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18 6.66671L10 13.3334L2 6.66671",
      stroke: "#09282A",
      "stroke-width": "1.25",
      "stroke-linecap": "square",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }